import { encodeArk } from '@fs/zion-ark'

export default function getEncodedArk(group) {
  if (!group) return null

  let encodedArk
  try {
    if (group?.imageApids?.length > 0) {
      // Always go to first image in image organize
      encodedArk = encodeArk(group.imageApids[0])
    } else {
      encodedArk = encodeArk(group.id)
    }
  } catch (e) {
    encodedArk = group.id
  }
  return encodedArk
}
